/*
 * Look switcher. Every page knows its look: a skin section carries data-a2-look, the home page is
 * "election-night", other pages (product, cart, collection) keep the look the visitor is browsing in.
 * A chosen look is remembered; "/" then opens that look's page. The cart attribute "Look" always
 * names the current look, so every order shows the look it was bought from.
 */
(function () {
  var html = document.documentElement;
  var DEF = 'election-night';
  var PAGES = {
    'election-night': '',
    'drop-01': 'pages/drop-01',
    'shirt-journey': 'pages/shirt-journey',
  };
  var K_CHOSEN = 'a2-look';
  var K_OK = 'a2-look-ok';
  var K_NOW = 'a2-look-now';
  var K_CART = 'a2-look-cart';

  function get(store, k) {
    try {
      return window[store].getItem(k);
    } catch (e) {
      return null;
    }
  }
  function set(store, k, v) {
    try {
      if (v === null) window[store].removeItem(k);
      else window[store].setItem(k, v);
    } catch (e) {}
  }

  var root = html.getAttribute('data-a2-root') || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';
  var template = html.getAttribute('data-a2-template') || '';
  var chosen = get('localStorage', K_CHOSEN);
  var ok = get('localStorage', K_OK);
  var usable = chosen && chosen !== DEF && chosen === ok && PAGES.hasOwnProperty(chosen) ? chosen : null;

  // a visitor who picked another look opens it instead of the home page (not for links to a home section)
  if (template === 'index' && usable && !location.hash && !html.hasAttribute('data-a2-design')) {
    location.replace(root + PAGES[usable] + location.search);
    return;
  }

  function cartToken() {
    var m = document.cookie.match(/(?:^|;\s*)cart=([^;]*)/);
    if (!m) return '';
    try {
      return decodeURIComponent(m[1]).split('?')[0];
    } catch (e) {
      return m[1];
    }
  }

  var busy = false;
  function syncCart(look) {
    var token = cartToken();
    if (!token || busy) return;
    if (get('sessionStorage', K_CART) === look + '|' + token) return;
    if (!window.fetch) return;
    busy = true;
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { Look: look } }),
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (cart && cart.attributes && cart.attributes.Look === look) set('sessionStorage', K_CART, look + '|' + (cartToken() || token));
      })
      .catch(function () {})
      .then(function () {
        busy = false;
      });
  }

  function start() {
    var skin = document.querySelector('[data-a2-look]');
    var pageLook = skin ? skin.getAttribute('data-a2-look') : template === 'index' ? DEF : null;
    if (pageLook) {
      set('sessionStorage', K_NOW, pageLook);
      // the chosen look's page really exists: from now on "/" may open it
      if (chosen && chosen === pageLook) set('localStorage', K_OK, pageLook);
    }
    var look = pageLook || get('sessionStorage', K_NOW) || usable || DEF;
    html.setAttribute('data-a2-look-now', look);

    var links = document.querySelectorAll('[data-a2-look-link]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.getAttribute('data-a2-look-link') === look) a.setAttribute('aria-current', 'true');
      else a.removeAttribute('aria-current');
      a.addEventListener('click', function (e) {
        var l = e.currentTarget.getAttribute('data-a2-look-link');
        if (l === DEF) {
          set('localStorage', K_CHOSEN, null);
          set('localStorage', K_OK, null);
        } else {
          set('localStorage', K_CHOSEN, l);
        }
      });
    }

    syncCart(look);
    document.addEventListener('cart:update', function () {
      setTimeout(function () {
        syncCart(look);
      }, 50);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
